import { TRANSACTION_ROUTE } from "_constants";
import { lazy } from "react";

const Transactions = lazy(() => import("pages/transactions"));

export const transactionsRoutes = [
  { path: TRANSACTION_ROUTE, element: <Transactions /> },
];
